import IconDelete from '../../../../components/icons/icon-delete/icon-delete';
import { ButtonIcon } from '../../../../components/inputs/button-icon/button-icon';

interface DeleteLocaleButtonProps {
    isDisabled: boolean;
    onClick: () => void;
}

const IconDeleteLocale = () => ( <IconDelete />);

const DeleteLocaleButton: React.FC<DeleteLocaleButtonProps> = ({ isDisabled, onClick }) => {
    return (
        <ButtonIcon Component={IconDeleteLocale} onClick={() => onClick()} disabled={isDisabled} />
    );
};

export default DeleteLocaleButton;
